import React from 'react'

type ContainerProps = {
  children: React.ReactNode
  testId?: string
}

export const Container: React.FC<ContainerProps> = ({ children, testId }) => {
  return (
    <div className="container mx-auto px-4 lg:px-12 xl:px-6 xxl:max-w-screen-xxxl" data-testid={testId ?? 'container'}>
      <div className="w-full">{children}</div>
    </div>
  )
}
